"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.symbol");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button"));

var _Util = require("../Util");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ActionButton = function ActionButton(props) {
  var newProps = (0, _Util.mergeProps)(props, ActionButton); // eslint-disable-next-line object-curly-newline

  var href = newProps.href,
      icon = newProps.icon,
      size = newProps.size,
      color = newProps.color,
      theme = newProps.theme,
      variant = newProps.variant,
      gradient = newProps.gradient,
      children = newProps.children,
      text = newProps.text,
      rest = _objectWithoutProperties(newProps, ["href", "icon", "size", "color", "theme", "variant", "gradient", "children", "text"]);

  var styles = {};

  if (gradient) {
    styles.backgroundImage = gradient;
    styles.borderColor = 'transparent';
  }

  var attrs = ['color', 'border', 'width'];
  attrs.forEach(function (x) {
    if (newProps[x]) {
      styles[x] = newProps[x];
    }
  });
  return _react["default"].createElement(_Button["default"], Object.assign({
    color: theme,
    href: href,
    target: "_blank",
    variant: variant,
    style: styles,
    size: size,
    className: "action-button"
  }, rest), !!icon && _react["default"].createElement("i", {
    className: icon
  }), text || children);
};

ActionButton.propTypes = {
  href: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].any,
  gradient: _propTypes["default"].string,
  color: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  border: _propTypes["default"].string,
  text: _propTypes["default"].string,
  theme: _propTypes["default"].string,
  variant: _propTypes["default"].string,
  size: _propTypes["default"].string,
  width: _propTypes["default"].string
};
ActionButton.defaultProps = {
  gradient: '',
  icon: '',
  text: '',
  color: '',
  border: '',
  width: '',
  theme: 'default',
  variant: 'outlined',
  size: 'large',
  children: null
};
var _default = ActionButton;
exports["default"] = _default;